import { replace } from 'connected-react-router';
import { SwitchVehicle } from '../../dashboard/ducks/actions';
import * as Services from '../services';

const ACTION_PREPEND = 'purchase/vehicle';
export const UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL = `${ACTION_PREPEND}/UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL`;

export const GET_VEHICLE_ID_FROM_STOCK_NUMBER = `${ACTION_PREPEND}/GET_VEHICLE_ID_FROM_STOCK_NUMBER`;
export const GET_STOCK_NUMBER_FROM_VEHICLE_ID = `${ACTION_PREPEND}/GET_STOCK_NUMBER_FROM_VEHICLE_ID`;
export const GET_COMPARE_VEHICLE_BY_VEHICLE_IDS = `${ACTION_PREPEND}/GET_COMPARE_VEHICLE_BY_VEHICLE_IDS`;
export const VERIFICATIONS_FETCH = `${ACTION_PREPEND}/VERIFICATIONS_FETCH`;

const convertStockNumberToVehicleId = payload => dispatch =>
  dispatch({
    type: GET_VEHICLE_ID_FROM_STOCK_NUMBER,
    async payload() {
      return Services.getVehicleIdFromStockNumber(payload);
    }
  });

const convertVehicleIdToStockNumber = payload => dispatch =>
  dispatch({
    type: GET_STOCK_NUMBER_FROM_VEHICLE_ID,
    async payload() {
      return Services.getStockNumberFromVehicleId(payload);
    }
  });

export const UpdateStockNumberAndOrVehicleId = () => async (
  dispatch,
  getState
) => {
  const { router: { location: { search, pathname } = {} } = {} } = getState();
  const searchParams = new URLSearchParams(search);

  let stockNumber = parseInt(searchParams.get('stock-number') || 0, 10);
  let vehicleId = parseInt(searchParams.get('vehicle-id') || 0, 10);
  const hasStockNumber = stockNumber && stockNumber > 0;
  const hasVehicleId = vehicleId && vehicleId > 0;

  if (hasStockNumber && !hasVehicleId) {
    const { value } = await dispatch(
      convertStockNumberToVehicleId(stockNumber)
    );
    const vid = Math.floor(value || 0);
    if (vid <= 0) return Promise.resolve();

    if (vid > 0) vehicleId = vid;

    searchParams.append('vehicle-id', value);
    searchParams.delete('stock-number');
    await dispatch(replace(`${pathname}?${searchParams.toString()}`));
  }

  if (!hasStockNumber && hasVehicleId) {
    const { value } = await dispatch(convertVehicleIdToStockNumber(vehicleId));
    const sn = parseInt(value || 0, 10);

    if (sn > 0) stockNumber = sn;
  }

  return dispatch({
    type: UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL,
    payload: {
      stockNumber,
      hasStockNumber: !!(stockNumber && stockNumber > 0),
      vehicleId,
      hasVehicleId: !!(vehicleId && vehicleId > 0)
    }
  });
};

export const GetCompareVehiclesByVehicleIds = (
  currentVehicleId,
  newVehicleId
) => dispatch =>
  dispatch({
    type: GET_COMPARE_VEHICLE_BY_VEHICLE_IDS,
    async payload() {
      return Services.getCompareVehiclesByVehicleId(
        currentVehicleId,
        newVehicleId
      );
    }
  });

export const GetVerifications = payload => dispatch =>
  dispatch({
    type: VERIFICATIONS_FETCH,
    async payload() {
      return Services.fetchVerifications(payload);
    }
  }).then(({ value }) => value);

export const SwitchVehicleAndRouteToDashboard = (vehicleId, sendCompleteEvent) => dispatch =>
  dispatch(SwitchVehicle(vehicleId, 'CustomerSelfSwapped'))
    .then(() => dispatch(UpdateStockNumberAndOrVehicleId()))
    .then(() => sendCompleteEvent(vehicleId, true))
    .then(() => {
      document.location.pathname = '/purchase';
    })
    .catch((err) => {
      sendCompleteEvent(vehicleId, false)
      throw err
    });

export const ContinuePurchaseAndRouteToDashboard = (vehicleId, sendCompleteEvent) => (
  dispatch,
  getState
) => {
  const {
    router: {
      location: { search, pathname }
    }
  } = getState();

  const searchParams = new URLSearchParams(search);
  searchParams.set('vehicle-id', vehicleId);

  return Promise.resolve(
    dispatch(replace(`${pathname}?${searchParams.toString()}`))
  )
    .then(() => dispatch(UpdateStockNumberAndOrVehicleId()))
    .then(() => sendCompleteEvent(vehicleId, true))
    .then(() => {
      document.location.pathname = '/purchase';
    })
    .catch((err) => {
      sendCompleteEvent(vehicleId, false)
      throw err
    });
};
